import styled from 'styled-components'

export const Headline = styled.div `
  color: black;
  font-size: 28px;
  font-family: serif;
  text-transform: uppercase;
`

export const Title = styled.div `
  color: black;
  font-size: 36px;
  font-weight: bold;
  font-family: serif;
  color: #DAB777;
`

export const SectionHeadline = styled.div `
  color: black;
  font-size: 28px;
  font-family: sans-serif;
  margin-top: 50px;
`

export const Text = styled.div `
  color: black;
  font-size: 16px;
`

export const Spacer = styled.div `
  width: 100%;
  height: 50px;
`

export const SubHeading = styled.h2 `
letter-spacing: 0.5;
padding-left: 15px;
font-family: "Catamaran";
font-weight: 300;
font-size: 18px;
color: #DAB777;
`
export const InverseH3 = styled.h3 `
  color: white;
  text-transform: uppercase;
  padding-top: 15px;
  padding-bottom: 15px;
  letter-spacing: 5px;
  text-align: center;
  font-size: 18px;
`


// WEBPACK FOOTER //
// /src/components/internal/GolfTournamentStyle.js